export const FETCH_ATTENDANCE_LIMIT = 5;
export const FETCH_COURSE_LIMIT = 5;
export const FETCH_ENROLMENT_LIMIT = 10;
export const FETCH_FACE_PHOTOS_LIMIT = 10;
export const FETCH_NOTIFICATION_LIMIT = 10;